import { jsx as _jsx } from "react/jsx-runtime";
import { FintechOutageBannerWithFetch, ACTION_CONTEXTS // @ts-expect-error ts-migrate(7016)
} from 'account-and-billing-fintech-outages';

const FintechFireAlarmBanner = () => {
  return /*#__PURE__*/_jsx(FintechOutageBannerWithFetch, {
    actionContext: ACTION_CONTEXTS.PURCHASE
  });
};

export default FintechFireAlarmBanner;